import { Card, CardContent, TextField } from "@mui/material";
import { useState, useEffect } from "react";

const CardWorkshopDate = ({
  dateStart,
  dateEnd,
  mode,
  setStartDate,
  setEndDate,
  isEditing,
  height,
  lastWorkshopCreated, // (queda para compatibilidad, ya no se usa)
}) => {
  const [formattedDateStart, setFormattedDateStart] = useState("");
  const [formattedDateEnd, setFormattedDateEnd] = useState("");

  // Helper: formatea a YYYY-MM-DD sin restricciones ni desplazamientos raros
  const toYMD = (value) => {
    if (!value) return "";
    if (typeof value === "string") {
      // si ya viene en ISO 'YYYY-MM-DD...' usamos los 10 primeros
      if (value.length >= 10 && /\d{4}-\d{2}-\d{2}/.test(value.slice(0, 10))) {
        return value.slice(0, 10);
      }
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  useEffect(() => {
    setFormattedDateStart(toYMD(dateStart));
    setFormattedDateEnd(toYMD(dateEnd));
  }, [dateStart, dateEnd]);

  const handleStartDateChange = (event) => {
    const v = event.target.value;
    setFormattedDateStart(v);
    setStartDate(v);
  };

  const handleEndDateChange = (event) => {
    const v = event.target.value;
    // 🔓 Sin validaciones: permitimos cualquier fecha
    setFormattedDateEnd(v);
    setEndDate(v);
  };

  return (
    <Card sx={{ mt: 2, width: "100%", height: height }}>
      <CardContent
        sx={{
          display: "flex",
          height: "100%",
          gap: "2%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextField
          fullWidth
          name="startDate"
          label="Fecha de Inicio"
          type="date"
          value={formattedDateStart}
          onChange={handleStartDateChange}
          disabled={!isEditing}
          InputLabelProps={{ shrink: true }}
          // 🔓 Sin min/max
        />
        <TextField
          fullWidth
          name="endDate"
          label="Fecha de Culminación"
          type="date"
          value={formattedDateEnd}
          onChange={handleEndDateChange}
          disabled={!isEditing}
          InputLabelProps={{ shrink: true }}
          // 🔓 Sin min/max
        />
      </CardContent>
    </Card>
  );
};

export default CardWorkshopDate;
